<template>
  <!--  预算编制-->
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed; top: 0; z-index: 999; width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames"
                  v-if="this.inputForm.invoice.auditGroup
                  && this.inputForm.invoice.auditGroup.auditGroupDetailList
                  && this.inputForm.invoice.auditGroup.auditGroupDetailList.length>0">
      <van-collapse-item title="汇总审批信息" name="99">
        <div  style="margin-bottom: 10px">
          <div class="m-form" style="padding-left: 0">
            <div class="m-row" style="font-size: 15px">
              <div class="m-row-text">单据类型</div>
              <div class="m-row-content">{{ inputForm.invoice.auditGroup.businessTypeName }}</div>
            </div>
            <div class="m-row" style="font-size: 15px">
              <div class="m-row-text">单据数量</div>
              <div class="m-row-content">{{ inputForm.invoice.auditGroup.businessNum }}</div>
            </div>
            <div class="m-row" style="font-size: 15px">
              <div class="m-row-text">总金额（元）</div>
              <div class="m-row-content">{{Number(inputForm.invoice.auditGroup.totalBusinessAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row" style="font-size: 15px">
              <div class="m-row-text">制单人</div>
              <div class="m-row-content">{{ inputForm.invoice.auditGroup.businessCreateByName }}</div>
            </div>
          </div>
        </div>
        <b-table  sticky-header="calc(100vh - 50px)" class="bgc-dark" head-variant="dark" responsive bordered
                  :items="inputForm.invoice.auditGroup.auditGroupDetailList" :fields="fields" :tbody-tr-class="rowClass">
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;font-size: 15px">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(businessCode)="data">
            <div @click="viewBusinessData(data.item.businessId)" style="text-align: left; font-size: 15px">
              {{ data.item.businessCode}}</div>
          </template>
          <template v-slot:cell(businessName)="data">
            <div @click="viewBusinessData(data.item.businessId)" style="text-align: left; font-size: 15px">
              {{ data.item.businessName}}</div>
          </template>
          <template v-slot:cell(remarks1)="data">
            <div @click="viewBusinessData(data.item.businessId)" style="text-align: left; font-size: 15px">
              {{ data.item.remarks1}}</div>
          </template>
          <template v-slot:cell(remarks2)="data">
            <div @click="viewBusinessData(data.item.businessId)" style="text-align: left; font-size: 15px">
              {{ data.item.remarks2}}</div>
          </template>
          <template v-slot:cell(businessAmount)="data">
            <div @click="viewBusinessData(data.item.businessId)" style="text-align: center; font-size: 15px">
              {{ Number(data.item.businessAmount).toFixed(2)}}</div>
          </template>
          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
        </b-table>
      </van-collapse-item>
    </van-collapse>

    <vatInvoiceFlowForm v-if="inputForm.invoice.type === 'vat_invoice'" ref="vatInvoiceFlowForm"></vatInvoiceFlowForm>
    <AGInvoiceFlowForm v-else-if="inputForm.invoice.type === 'ag_invoice'" ref="AGInvoiceFlowForm"></AGInvoiceFlowForm>
    <vehicleInvoiceFlowForm v-else-if="inputForm.invoice.type === 'motor_vehicle_invoice'" ref="vehicleInvoiceFlowForm"></vehicleInvoiceFlowForm>
    <otherInvoiceFlowForm v-else ref="otherInvoiceFlowForm"></otherInvoiceFlowForm>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../components/processRecord/processRecord";
import TaskService from "../../../../api/flowable/TaskService";
import ProcessService from "../../../../api/flowable/ProcessService";
import QueryInfoService from '@/api/system/queryInfoService'
import Decimal from "decimal.js";
import Vue from "vue";
import flowSettingService from "../../../../api/sys/flowSettingService";
import invoiceFlowService from "../../../../api/cost/invoiceFlowService";
import vatInvoiceFlowForm from "./vatInvoiceFlowForm.vue";
import AGInvoiceFlowForm from "@/views/pages/cost/invoice/AGInvoiceFlowForm.vue";
import vehicleInvoiceFlowForm from "@/views/pages/cost/invoice/vehicleInvoiceFlowForm.vue";
import otherInvoiceFlowForm from "@/views/pages/cost/invoice/otherInvoiceFlowForm.vue";
export default {
  name: "invoiceFlow",
  data() {
    return {
      activeNames: ['1', '2', '3','4','5','99'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        invoice: {
          type: '',
          auditGroup: {
            id: undefined,
            businessTypeName: undefined,
            businessNum: undefined,
            totalBusinessAmount: undefined,
            businessCreateByName: undefined,
            auditGroupDetailList: []
          },
        },
      },
      businessType: 'vat_invoice',
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '40px'},
        {key: 'businessCode', label: '发票号码', width: '120px'},
        {key: 'businessName', label: '发票种类', width: '120px'},
        {key: 'remarks1', label: '购方名称', width: '140px'},
        {key: 'remarks2', label: '销售方名称', width: '140px'},
        {key: 'businessAmount', label: '金额（元）', width: '120px'},
        // {key: 'code', label: '单据编号', width: '150px'},
        // {key: 'name', label: '单据名称', width: '120px'},
        // {key: 'requestAmount', label: '金额', width: '50px'},
      ],
    }
  },
  components: {
    processRecord,
    vatInvoiceFlowForm,
    AGInvoiceFlowForm,
    vehicleInvoiceFlowForm,
    otherInvoiceFlowForm
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if (!window.matchMedia("(orientation:portrait)").matches) {
      dd.device.screen.resetView({
        onSuccess: function (result) {
        },
        onFail: function (err) {
        }
      });
    }
  },
  methods: {
    getAdjustTypeName(value){
      let name = ''
      this.adjustTypeList.forEach(item => {
        if(item.name == value){
          name = item.label
        }
      })
      return name
    },
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.inputForm.id = id
      new invoiceFlowService().queryByIdAndType(id).then(({data}) => {
        this.inputForm = data
        this.$nextTick(()=>{
          switch (this.inputForm.invoice.type) {
            case 'vat_invoice':
              this.$refs.vatInvoiceFlowForm.init(data)
              break
            case 'ag_invoice':
              this.$refs.AGInvoiceFlowForm.init(data)
              break
            case 'motor_vehicle_invoice':
              this.$refs.vehicleInvoiceFlowForm.init(data)
              break
            default :
              this.$refs.otherInvoiceFlowForm.init(data)
          }
        })
      })
    },
    // 数据字典获取
    getDict(dicts) {
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({data}) => {
          this.$set(this.inputForm, `${formField}Name`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        }).catch(e => {
          console.log(e)
        })
      });
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then( async () => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        let sendBy = ''
        let sendByDeptId = ''
        let sendByCompanyId = ''
        if(this.inputForm.invoice.flowStatus === 1) {
          sendBy = Vue.cookie.get('userId');
          const res1 = await new flowSettingService().queryUser(sendBy)
          sendByDeptId = res1.data.officeDTO.id
          sendByCompanyId = res1.data.companyDTO.id
        } else {
          const res3 = await new TaskService().queryByProcInsId(this.inputForm.invoice.procInsId)
          sendBy = res3.data.createBy
          sendByDeptId = res3.data.createDept
          sendByCompanyId = res3.data.createCompany
        }
        let createByDeptId = ''
        let createByCompanyId = ''
        const res2 = await new flowSettingService().queryUser(this.inputForm.invoice.createBy)
        createByDeptId = res2.data.officeDTO.id
        createByCompanyId = res2.data.companyDTO.id
        vars = {
          sendBy: sendBy,
          sendByDeptId: sendByDeptId,
          sendByCompanyId: sendByCompanyId,
          createBy: this.inputForm.createBy,
          createByDeptId: createByDeptId,
          createByCompanyId: createByCompanyId
        }
        // vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.invoice.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/cost/invoice/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.invoice.id,
            flowType: 3,
            formKey: _this.formKey
          }
          _this.$flow.startFlow(form, '/cost/invoice/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    viewBusinessData(id){
      this.init(id)
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.businessId == this.inputForm.invoice.id){
        return 'success'
      }
      // return ''
    }
  }
}
</script>

<style scoped>
::v-deep .success td {
  background-color: #d1e7dd!important;
}
* {
  margin: 0;
  padding: 0;
}

.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}

.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
